import React from 'react';
import { Grid, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import SideBarContainer from 'Containers/SideBarContainer';
import Panel from 'Containers/Panel';
import ListItems from 'Containers/ListItems';
import useTranslation from 'Hooks/useTranslation';
import useFetch from './Hooks/useFetch';
import PanelHeader from './Components/PanelHeader';
import Calendar from './Components/Calendar';
import Trainings from './Components/Trainings';
import Documents from './Components/Documents';
import WelcomeMessage from './Components/WelcomeMessage';
import ListCards from './Components/ListCards';
import CourseCardSkeleton from './Components/CourseCardSkeleton';
import { PanelBody, PanelBodyItem, Courses, CoursesTitle, ButtonStyle } from './style';

export default function Dashboard() {
  const { t2 } = useTranslation('Dashboard');
  const { fullName, payrollNum, email, id, photo } = useSelector(userSelector);
  const { documents, events, recentlyUpdateCourses, remoteTraining } = useFetch({ userId: id });

  document.body.style.overflow = 'auto';
  return (
    <SideBarContainer navBar={false}>
      <Grid container>
        <Grid item xs flexDirection="column">
          <WelcomeMessage name={fullName} />
          <div style={{ width: '90%', margin: 'auto', marginTop: '1em' }}>
            <Courses>
              <CoursesTitle>{t2('RecentTrainings')}</CoursesTitle>
              <Button variant="text" style={ButtonStyle}>
                {t2('SeeAll')}
              </Button>
            </Courses>
            {recentlyUpdateCourses === null ? (
              <CourseCardSkeleton />
            ) : (
              <ListCards information={recentlyUpdateCourses} />
            )}
          </div>
        </Grid>
        <Grid item minWidth={350} maxHeight="100vh">
          <Panel>
            <PanelHeader name={fullName} email={email === null ? payrollNum : email} image={photo} />
            <PanelBody>
              <PanelBodyItem>
                <Calendar events={events} />
              </PanelBodyItem>
              <PanelBodyItem>
                <ListItems title={t2('RemoteTraining')}>
                  {remoteTraining?.length > 0 && <Trainings items={remoteTraining} />}
                </ListItems>
              </PanelBodyItem>
              <PanelBodyItem>
                <ListItems title={t2('Documents')}>
                  <Documents items={documents} />
                </ListItems>
              </PanelBodyItem>
            </PanelBody>
          </Panel>
        </Grid>
      </Grid>
    </SideBarContainer>
  );
}
